import { useEffect, useRef, useState } from "react"
import "./index.css"
import _ from "../../../_"
import Glass from "../../custom/glass"

const ContextMenu = ({ config, close, orientation }) => {

    const ref = useRef()

    useEffect(() => {
        ref.current && ref.current.focus()
    }, [])

    const handleBlur = () => {
        close && close()
    }

    return (
        <>
            <Glass opacity={0}/>
            <div ref={ref} className={`cm-root ${orientation}`} tabIndex={0} onBlur={handleBlur}>
                {
                    config.map((c, i) => <div className={`cm-item ${config.length-1==i?'last':''} ${c.className || ''}`} onClick={()=>{
                        c.onClick()
                        close()
                    }}>{c.name}</div>)
                }
            </div>
        </>
    )
}

export default ContextMenu

